import { fetchDataAndProceed } from '../../config/utils';
import { METHOD_TYPES } from '../../config/constants';

export const fetchAllEntities = (data, callback) => {
    return fetchDataAndProceed('admin/v1/botBuilder/entities', METHOD_TYPES.GET, data, callback);
};

export const deleteEntity = (data, callback) => {
    return fetchDataAndProceed('admin/v1/botBuilder/entity', METHOD_TYPES.DELETE, data, callback);
};

export const createEntity = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/entity', METHOD_TYPES.POST, data, callback);
};

export const getEntityData = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/botBuilder/entity', METHOD_TYPES.GET, data, callback);
};

// export const getSimpleEntity = (data, callback) => {
//     return fetchDataAndProceed('/admin/v1/botBuilder/entity', METHOD_TYPES.GET, data, callback);
// };

// export const getHierarchicalEntity = (data, callback) => {
//   return fetchDataAndProceed('/admin/v1/botBuilder/entity', METHOD_TYPES.GET, data, callback);
// };

// export const getListEntity = (data, callback) => {
//   return fetchDataAndProceed('/admin/v1/botBuilder/entity', METHOD_TYPES.GET, data, callback);
// };

export const updateEntity = (data, callback) => {
  return fetchDataAndProceed('admin/v1/botBuilder/entity', METHOD_TYPES.PUT, data, callback);
};


// WEBPACK FOOTER //
// ./src/data/redux/entity_details/api.js